export const APP_ALERT = 'APP_ALERT';
export const APP_ALERT_DISMISS = 'APP_ALERT_DISMISS';
export const APP_CONFIRM = 'APP_CONFIRM';
export const APP_CONFIRM_DISMISS = 'APP_CONFIRM_DISMISS';
export const APP_PROMPT = 'APP_PROMPT';
export const APP_PROMPT_DISMISS = 'APP_PROMPT_DISMISS';
export const APP_NOTIFY = 'APP_NOTIFY';

let dialogPromise;
let dialogResolve;

export function alert(message) {
  dialogPromise = new Promise(resolve => {
    dialogResolve = resolve;
  });
  return {
    type: APP_ALERT,
    message,
    payload: dialogPromise,
  };
}

export function alertDismiss(index) {
  if (dialogResolve) dialogResolve();
  return { type: APP_ALERT_DISMISS, index };
}

export function confirm(message) {
  dialogPromise = new Promise(resolve => {
    dialogResolve = resolve;
  });
  return {
    type: APP_CONFIRM,
    message,
    payload: dialogPromise,
  };
  // return { type: APP_CONFIRM, message }
}
export function confirmDismiss(response, index) {
  if (response === undefined) response = false;
  if (dialogResolve) dialogResolve(response);
  return { type: APP_CONFIRM_DISMISS, response, index };
}

export function prompt(message) {
  dialogPromise = new Promise(resolve => {
    dialogResolve = resolve;
  });
  return {
    type: APP_PROMPT,
    message,
    payload: dialogPromise,
  };
  // return { type: APP_CONFIRM, message }
}
export function promptDismiss(response, index) {
  if (response === undefined) response = null;
  if (dialogResolve) dialogResolve(response);
  return { type: APP_PROMPT_DISMISS, response, index };
}

export function notify(message) {
  return { type: APP_NOTIFY, message };
}
